<template>
  <FlexTable class="polls-table">
    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
    <transition-group name="polls-transition">
      <div class="flex-trow" v-for="(poll, index) in dataPolls.slice(startIndex, endIndex)" :key="'poll-'+poll.id">
        <div class="remove-poll" @click="showModal(startIndex + index)">x</div>
        <div class="right-menu">
          <div class="right-menu-btn" @click="goToPoll(poll.id)">Ir</div>
        </div>
        <div class="flex-td name-cell">{{poll.created_at}}</div>
      </div>
    </transition-group>
  </FlexTable>
</template>

<script>
import FlexTable from "./base/FlexTable"
import pollsService from "../../services/pollsService"

export default {
  name: "PollsTable",
  components: { FlexTable },
  model: {
    prop: "polls",
    event: "change"
  },
  props: {
    polls: {
      type: Array,
      default: function() {
        return []
      }
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  methods: {
    showModal(index) {
      // we must pass object params with all the information
      const params = {
        title: 'Eliminar encuesta',
        text: 'Estas seguro que quieres eliminar la encuesta?',
        // we are passing callback method for our confirm button
        onConfirm: () => {
          return this.deletePoll(index)
        }
      };
      // now we can call function that will reveal our modal
      this.$deleteModal.show(params)
    },
    deletePoll: function(index) {
      pollsService.delete_entry_poll({ id: this.dataPolls[index].id , authenticated: true }).then(
        data => {
          this.dataPolls.splice(index, 1)
          this.$toasted.success(data.message)
        },
        error => {
          this.$toasted.success("Ha ocurrido un error!");
          console.error(error);
        }
      );
    },
    goToPoll: function(id) {
      this.$router.push({ name: "entry_poll_admin", params: { id: id } })
    }
  },
  watch: {
    dataPolls: function(val) {
      this.$emit("change", val)
    },
    polls: function(val) {
      this.dataPolls = val
    }
  },
  data: function() {
    return {
      dataPolls: this.polls,
      currentPage: 1
    };
  },
  computed: {
    rows() {
      return this.dataPolls.length;
    },
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      return this.currentPage * this.perPage;
    }
  }
};
</script>

<style scoped lang="scss">
.polls-table {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  width: 100%;

  & span {
    width: 100%;
  }
}

.name-cell {
  padding-left: 3rem;
}

.flex-trow {
  position: relative;
  border-left: 1px solid $gray-500;
  border-right: 1px solid $gray-500;
  border-bottom: 1px solid $gray-300;


  & .right-menu {
    position: absolute;
    height: 100%;
    right: 0;
    display: flex;

    & .right-menu-btn {
      border-left: 1px solid $gray-500;
      padding: 0.75rem;
      min-width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: rgb(23, 162, 184);
      color: white;
      height: 100%;
    }
    
    & .right-menu-btn:hover {
      background-color: rgb(21, 146, 165);
    }
  }

  &:first-child {
    border-top: 1px solid $gray-500;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    & .right-menu .right-menu-btn:last-child {
      border-top-right-radius: 10px;
    }
  }

  &:last-child {
    border-bottom: 1px solid $gray-500;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;


    & .right-menu .right-menu-btn:last-child {
      border-bottom-right-radius: 10px;
    }
  }

  & .remove-poll {
    display: none;
    position: absolute;
    margin: -0.5px;
    height: 100%;
    align-items: center;
    width: 32px;
    justify-content: center;
    color: black;
    background-color: rgba(grey, 0.1);
  }

  &:hover .remove-poll {
    display: flex;
    cursor: pointer;
  }

  &:first-child .remove-poll {
    border-top-left-radius: 10px;
  }

  &:last-child .remove-poll {
    border-bottom-left-radius: 10px;
  }
}

.flex-td {
  justify-content: flex-start;
  text-align: left;
  border: none;
}

.polls-transition-enter-active,
.polls-transition-leave-active {
  transition: opacity 0.2s;
}

.polls-transition-enter,
.polls-transition-leave-to {
  opacity: 0;
}

.polls-transition-leave,
.polls-transition-enter-to {
  opacity: 1;
}
</style>